<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col md="6" sm="12">

          <b-form-group label-size='lg'  label='Organization Name' label-for='title' :horizontal='false'>
            <b-form-input
              data-vv-name="organization.title"
              v-validate="'required|max:255|uniqueOrgName'"
              data-vv-as="Organization Name"
              size="lg"
              id='title'
              v-model='organization.title'>
            </b-form-input>
            <span v-show="inputValidationErrors.has('organization.title')" class="text-info">{{ inputValidationErrors.first('organization.title') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='adduserlabel' label='Street' label-for='mailingStreet' :horizontal='false'>
            <b-form-input
              type="text"
              size="lg"
              v-validate="'max:255'"
              data-vv-name="organization.mailingStreet"
              data-vv-as="Street"
              id='mailingStreet'
              v-model='organization.mailingStreet'
            ></b-form-input>
            <span v-show="inputValidationErrors.has('organization.mailingStreet')" class="text-info">{{ inputValidationErrors.first('organization.mailingStreet') }}</span>
          </b-form-group>

          <b-form-group label-size='lg'  label='City' label-for='mailingCity' :horizontal='false'>
            <b-form-input
              type="text"
              size="lg"
              v-validate="'required|max:255'"
              data-vv-name="organization.mailingCity"
              data-vv-as="City"
              id='mailingCity'
              v-model='organization.mailingCity'
            ></b-form-input>
            <span v-show="inputValidationErrors.has('organization.mailingCity')" class="text-info">{{ inputValidationErrors.first('organization.mailingCity') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label="County / Parish" label-for="county"  label-class='addpersonlabel'>
              <!-- <v-select
                id='county'
                :options="countyOptions"
                v-model="organization.county"
                placeholder="Search"
              >
              </v-select> -->
              <b-form-select size="lg"
                v-validate="checkIfRequired"
                data-vv-name="organization.county"
                data-vv-as="County"
                :options="countyOrParishOptions" id='county' v-model='organization.county'>
              </b-form-select>
            </b-form-group>

          <b-form-group label-size='lg' label='State' label-for='mailingState' :horizontal='false'>
            <b-form-select size="lg"
            @change="updateStateAbbr()"
            v-validate="'required'"
            data-vv-name="organization.mailingState"
            data-vv-as="State"
            :options="mailingStateOptions()" id='mailingState' v-model='organization.mailingState'>
            </b-form-select>
            <span v-show="inputValidationErrors.has('organization.mailingState')" class="text-info">{{ inputValidationErrors.first('organization.mailingState') }}</span>
          </b-form-group>

          <b-form-group label-size='lg'  label='Postal Code' label-for='mailingPostalCode' :horizontal='false'>
            <b-form-input
              type="text"
              size="lg"
              data-vv-name="organization.mailingPostalCode"
              v-validate="'max:255'"
              data-vv-as="Postal Code"
              id='mailingPostalCode'
              v-model='organization.mailingPostalCode'>
              </b-form-input>
            <span v-show="inputValidationErrors.has('organization.mailingPostalCode')" class="text-info">{{ inputValidationErrors.first('organization.mailingPostalCode') }}</span>
          </b-form-group>

          <b-form-group label-size='lg' label-class='addgrouplabel' label='Organization Type' label-for='organizationTypes' :horizontal='false'>
            <treeselect
              :value="organization.organizationTypes"
              @select="handleSelect"
              @deselect="handleDeselect"
              :multiple="true"
              :options="organizationTypesOptions(organizationTypeCheck)"
            />
            <span v-show="inputValidationErrors.has('organization.organizationTypes')" class="text-info">{{ inputValidationErrors.first('organization.organizationTypes') }}</span>
          </b-form-group>
          <b-form-group label-size='lg' label-class='addgrouplabel' label='Group Memberships' label-for='memberOrgs' :horizontal='false'>
            <treeselect
              v-model="organization.memberGroups"
              :multiple="true"
              :options="groupOptions(groups)"
              />
              <span v-show="inputValidationErrors.has('organization.memberGroups')" class="text-info">{{ inputValidationErrors.first('organization.memberGroups') }}</span>
          </b-form-group>

          <b-form-group v-if="isNew" label-size='lg' label='Program' :horizontal='false'>
            <div class="program-list" v-for="program in newProgramOptions" :key="program.title">
              <label class="col-form-label pt-0 col-form-label-lg">{{ program.title !== 'Other' ? program.title : program.title_otherText }}</label>
              <img v-if="program.isDefault" :src="'static/img/Primary.png'" height="21" width="21">
            </div>
            <b-button type="button" variant="outline-primary" size="md" @click="showCreateProgramModal = true">
              <span class="button-text">Add Program</span>
            </b-button>
          </b-form-group>

          <b-form-group v-if="isNew" label-size='lg' label='Location' :horizontal='false'>
            <div class="location-list" v-for="location in newLocationOptions" :key="location.title">
              <label class="col-form-label pt-0 col-form-label-lg">{{ location.title }}</label>
              <img v-if="location.isDefault" :src="'static/img/Primary.png'" height="21" width="21">
            </div>
            <b-button type="button" variant="outline-primary" size="md" @click="showCreateLocationModal = true">
              <span class="button-text">Add Location</span>
            </b-button>
          </b-form-group>

          <b-form-group v-if="!isNew" label-size='lg' label='Default Program' label-for='defaultProgram' :horizontal='false'>
            <b-form-select size="lg"
            :options="programOptions" id='defaultProgram' v-model='organization.defaultProgram'>
            </b-form-select>
          </b-form-group>

          <b-form-group v-if="!isNew" label-size='lg' label='Default Location' label-for='defaultLocation' :horizontal='false'>
            <b-form-select size="lg"
            :options="locationOptions" id='defaultLocation' v-model='organization.defaultLocation'>
            </b-form-select>
          </b-form-group>

          <b-form-group label-size='lg'  label='Data Warehouse User Seats' label-for='licenseDW' :horizontal='false'>
            <b-form-input
              data-vv-name="organization.licenseDW"
              data-vv-as="User Licenses"
              size="lg"
              id='licenseDW'
              v-model='organization.licenseDW'>
            </b-form-input>
          </b-form-group>

          <p>Number of Used Seats: ( {{ getLicenseNumber(organizationMemberships) }} / {{ organization.licenseDW}} )</p>
        </b-col>
      </b-row>
    </b-card>
    <CreateProgramModal
      :showModal.sync = "showCreateProgramModal"
      :isNewOrg="isNew"
      :orgPrograms="newProgramOptions"
      v-on:updateNewProgram="updateNewProgram"
      :orgState="organization.mailingStateAbbreviation"
    >
    </CreateProgramModal>
    <CreateLocationModal
      :showModal.sync = "showCreateLocationModal"
      :isNewOrg="isNew"
      :orgLocations="newLocationOptions"
      v-on:updateNewLocation="updateNewLocation"
    >
    </CreateLocationModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import CreateProgramModal from '@/components/Admin/CreateProgramModal'
import CreateLocationModal from '@/components/Admin/CreateLocationModal'

export default {
  name: 'create-organization-form',
  props: {
    organization: {
      type: Object,
      default: () => {
        return { memberGroups: Array }
      }
    },
    isNew: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  components: {
    Treeselect,
    CreateProgramModal,
    CreateLocationModal
  },
  computed: {
    ...mapGetters({
      isSuperAdminOptions: 'getIsSuperAdminOptions',
      groups: 'getAllGroups',
      organizationTypes: 'getAllOrganizationTypes',
      organizationTypesLA: 'getAllOrganizationTypesLA',
      stateAndAbbrev: 'getStateAndAbbrev',
      orgPrograms: 'getProgramsByOrg',
      orgLocations: 'getLocationsByOrg',
      organizationMemberships: 'getOrgMembers',
      countyOptions: 'getCountyData',
      parishOptions: 'getLAParishData'
    }),
    countyOrParishOptions () {
      switch (this.organization.mailingStateAbbreviation) {
        case 'TX':
          return this.countyOptions
        case 'LA':
          return this.parishOptions
        default:
          return []
      }
    },
    organizationTypeCheck () {
      switch (this.organization.mailingStateAbbreviation) {
        case 'TX':
          return this.organizationTypes
        case 'LA':
          return this.organizationTypesLA
        default:
          return []
      }
    },
    checkIfRequired () {
      switch (this.organization.mailingStateAbbreviation) {
        case 'TX':
        case 'LA':
          return 'required'
        default:
          return ''
      }
    }
  },

  inject: ['$validator'],

  data: function () {
    return {
      tabIndex: 0,
      existingGroups: this.organization.memberGroups,
      programOptions: [],
      locationOptions: [],
      newProgramOptions: [],
      newLocationOptions: [],
      showCreateProgramModal: false,
      showCreateLocationModal: false
    }
  },
  watch: {
    orgPrograms: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        this.programOptions = clonedValue.map((program) => {
          let text = program.title
          if (program.title === 'Other') {
            text = program.title_otherText
          }
          return {value: program.id, text}
        })
      }
    },
    orgLocations: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        var newArray = clonedValue.filter((value) => !value.isRemoved)
        this.locationOptions = newArray.map((location) => {
          return {value: location.id, text: location.title}
        })
      }
    }
  },
  created: function () {
    if (this.organization.id) {
      this.$store.dispatch('getOrgUserMemberships', {
        morganization: this.organization.id,
        populate: 'muser'
      })
    }
    this.searchGroups()
    this.$validator.extend('uniqueOrgName', {
      getMessage: field => 'Organization name already exist. Please enter different name',
      validate: (value) => {
        return this.validateOrgName()
      }
    })
  },
  methods: {
    updateStateAbbr () {
      this.organization.mailingStateAbbreviation = _.result(_.find(this.stateAndAbbrev, obj => {
        return obj.text === this.organization.mailingState
      }), 'value')
    },
    mailingStateOptions () {
      return _.sortBy(this.stateAndAbbrev, 'text').map((state) => {
        return {value: state.text, text: state.text}
      })
    },
    groupOptions (groups) {
      return groups.map((group) => {
        return {
          id: group.id,
          label: group.groupName,
          isDisabled: this.existingGroups && (this.existingGroups.indexOf(group.id) > -1)
        }
      })
    },
    validateOrgName () {
      return this.$store.dispatch('validateOrgName', _.trim(this.organization.title)).then((response) => {
        return !(response.length > 0 && response.map((x) => x.id).indexOf(this.organization.id) === -1)
      })
    },
    getLicenseNumber (members) {
      let rdyMembers = _.filter(members, ['isDWUser', true])
      return rdyMembers.length
    },
    searchGroups () {
      this.$store.dispatch('getAllGroups', {})
      this.$store.dispatch('getLocationsByOrg', { orgId: this.organization.id })
      this.$store.dispatch('getProgramsByOrg', { orgId: this.organization.id })
    },
    organizationTypesOptions (options) {
      return options.map((option) => {
        return {
          id: option.value,
          label: option.text,
          checked: true
        }
      })
    },
    handleSelect (option) {
      const index = this.organization.organizationTypes.indexOf(option.id)
      if (index < 0) {
        if (!this.organization.id) {
          this.$store.commit('addToCreateOrgTypes', option.id)
        } else {
          this.$store.commit('addToEditOrgTypes', option.id)
        }
      }
    },
    handleDeselect (option) {
      const index = this.organization.organizationTypes.indexOf(option.id)
      if (index > -1) {
        if (!this.organization.id) {
          this.$store.commit('removeFromCreateOrgTypes', option.id)
        } else {
          this.$store.commit('removeFromEditOrgTypes', option.id)
        }
      }
    },
    updateNewProgram (newProgram) {
      if (newProgram.isDefault) {
        this.newProgramOptions = this.newProgramOptions.map((program) => {
          program.isDefault = false
          return program
        })
      }
      const index = this.newProgramOptions.indexOf(newProgram)
      if (index <= -1) {
        this.newProgramOptions.push(newProgram)
      }
      this.organization.programs = this.newProgramOptions
    },
    updateNewLocation (newLocation) {
      if (newLocation.isDefault) {
        this.newLocationOptions = this.newLocationOptions.map((location) => {
          location.isDefault = false
          return location
        })
      }
      const index = this.newLocationOptions.indexOf(newLocation)
      if (index <= -1) {
        this.newLocationOptions.push(newLocation)
      }
      this.organization.locations = this.newLocationOptions
    }
  }
}
</script>
<style scoped>
  h3 {
    display: inline-block;
  }
  img {
    vertical-align: text-bottom;
  }
  .program-list, .location-list {
    padding-left: 20px;
  }
</style>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>


// WEBPACK FOOTER //
// src/views/t1/Admin/OrganizationForm.vue